import { isAndroid } from './user-agent-detector'

export const getCapitalizedText = (string: string) =>
  string.charAt(0).toUpperCase() + string.slice(1)

export const parseWithWordBreak = (contents: string): string =>
  contents?.replace(/ /g, `\u00a0`).replace(/\n/g, ' ')

/**
 * 전화번호를 (123) 456-7890 형식으로 리턴합니다.
 */
export const getFormattedNumber = (phoneNumber: string) => {
  let result = ''

  if (phoneNumber.length > 0) {
    result += phoneNumber
  }

  if (phoneNumber.length > 3) {
    result = `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}`
  }

  if (phoneNumber.length > 6) {
    result += `-${phoneNumber.slice(6)}`
  }

  return result
}

export const handleTextLength = (text: string, maxLength: number) => {
  if (isAndroid) {
    return text.substring(0, maxLength)
  }

  return text
}

export const sanitizeLineBreaks = (text: string) => text.replace('\b', '').replace(/\u2028/g, '\n')
